module.exports = __webpack_public_path__ + "img/icon_gdxm@2x.07d5d34e.png";